import { inject } from "ui-common/di";
import type { IRpcService } from "ui-common/services/rpc/types";
import type { BrandsSearchResult } from "api-contracts/rpc/brands-search";
import type { IWritableBackofficeBrandsState, IBackofficeBrandsService } from "./types";

export class BackofficeBrandsService implements IBackofficeBrandsService {
  @inject<IWritableBackofficeBrandsState>("writableBackofficeBrandsState")
  private state!: IWritableBackofficeBrandsState;

  @inject<IRpcService>("rpcService")
  private rpcService!: IRpcService;

  private pendingSearch: Promise<void> | undefined;
  private currentSearchKey = "";

  searchBrands(searchTerm: string, selectedBrandIds: string[] = []): void {
    if (!searchTerm && selectedBrandIds.length === 0) {
      this.state.brands.set(null);
      this.state.loading.set(false);
      return;
    }

    const searchKey = `${searchTerm}:${selectedBrandIds.join(",")}`;
    if (searchKey === this.currentSearchKey && this.pendingSearch) return;

    this.currentSearchKey = searchKey;
    this.state.loading.set(true);
    this.pendingSearch = this.doSearch(searchTerm, selectedBrandIds);
  }

  clearBrands(): void {
    this.state.brands.set(null);
    this.state.loading.set(false);
    this.pendingSearch = undefined;
    this.currentSearchKey = "";
  }

  private async doSearch(searchTerm: string, selectedBrandIds: string[]): Promise<void> {
    try {
      const result = await this.rpcService.call<BrandsSearchResult>("brandsSearch", {
        searchTerm,
        selectedBrandIds,
      });
      this.state.brands.set(result);
    } catch (error) {
      console.error("[BackofficeBrandsService] Error searching brands:", error);
    } finally {
      this.state.loading.set(false);
      this.pendingSearch = undefined;
    }
  }
}
